/* Raw Elements, Conversion-Motion (TubeBridge 2026-08-07)
   L2 Warenkorb-Bestaetigung am ATC-Button + L3 Gratisversand-Fortschritt im
   Warenkorb-Drawer. Laeuft unabhaengig von prefers-reduced-motion.
   2026-08-07 (P2): directAddOnCards -> Karten-ATC one-click.
   2026-10-08: Gratis Cafe-Dose ab 29 EUR (bestehende Variante Kaffee 30 g, kein neues Produkt),
   Zahlarten-Reihe und "Sicher zur Kasse" im Drawer. Das Geschenk wird nur im Warenkorb gehalten,
   wenn Shopify es wirklich gratis rechnet (Rabatt "Gratis Cafe-Dose ab 29 EUR"). Sonst wird es wieder entfernt. */
(function () {
  'use strict';
  var THRESHOLD = 2900;
  var GIFT_ID = 55529281225084;
  var GIFT_PROP = '_re_gratis';
  var GIFT_BROKEN_KEY = 're_gift_broken';
  var JSONH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var giftBusy = false;
  var GIFT_SVG = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M5 12v9h14v-9"/><path d="M7.5 8a2.5 2.5 0 1 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 1 1 0 5"/></svg>';

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action^="/cart/add"]')) return;
    var btn = form.querySelector('button[type="submit"], .product-form__submit');
    if (!btn) return;
    btn.classList.add('re-added');
    setTimeout(function () { btn.classList.remove('re-added'); }, 1700);
  }, true);

  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }

  /* Kundenstimmen (#re-tstm-pdp, via theme.liquid ganz unten gerendert) direkt
     UNTER die Sektion "Wie unser Matcha entsteht" (.re-proz) einhaengen, wenn
     diese existiert. Sonst nichts tun -> Snippet bleibt unten. */
  function moveTestimonials() {
    var _t = document.getElementById('re-tstm-pdp');
    var _p = document.querySelector('.re-proz');
    if (_t && _p) { var _s = _p.closest('.shopify-section') || _p; if (_s.parentNode) _s.parentNode.insertBefore(_t, _s.nextSibling); }
  }

  function injectStyle() {
    if (document.getElementById('re-cart-style')) return;
    var s = document.createElement('style');
    s.id = 're-cart-style';
    s.textContent =
      '.re-freeship__track{position:relative;overflow:visible}' +
      '.re-freeship__mark{position:absolute;top:50%;right:-3px;transform:translateY(-50%);width:22px;height:22px;border-radius:50%;background:#C16B4A;color:#FBF7EF;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(193,107,74,.3)}' +
      '.re-freeship__sub{margin:8px 0 0;font-size:11.5px;line-height:1.35;text-align:center;color:#6D6A5C}' +
      '.re-freeship__sub:empty{display:none}' +
      '.re-cart-pay{padding:2px 0 0;text-align:center}' +
      '.re-cart-pay__label{margin:0 0 8px;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#8A8270}' +
      '.re-cart-pay__list{display:flex;flex-wrap:wrap;justify-content:center;gap:6px;margin:0;padding:0;list-style:none}' +
      '.re-cart-pay__item{display:flex;align-items:center;justify-content:center;width:44px;height:30px;background:#FBF7EF;border:1px solid #E2D9C6;border-radius:6px;overflow:hidden}' +
      '.re-cart-pay__item svg{height:20px;width:auto;max-width:36px;display:block}' +
      '.re-cart-pay__note{margin:8px 0 0;font-size:12px;line-height:1.4;color:#6D6A5C}';
    document.head.appendChild(s);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); });
  }
  function isGift(item) { return item.variant_id === GIFT_ID && item.properties && item.properties[GIFT_PROP]; }
  function giftLine(cart) { var l = null; cart.items.forEach(function (i) { if (isGift(i)) l = i; }); return l; }
  function paidTotal(cart) {
    var t = 0;
    cart.items.forEach(function (i) { if (!isGift(i)) t += i.final_line_price; });
    return t;
  }
  function giftBroken() {
    try { var t = parseInt(sessionStorage.getItem(GIFT_BROKEN_KEY) || '0', 10); return t && Date.now() - t < 30 * 60 * 1000; } catch (e) { return false; }
  }
  function markGiftBroken() { try { sessionStorage.setItem(GIFT_BROKEN_KEY, String(Date.now())); } catch (e) {} }

  /* Drawer frisch rendern lassen (Shopify Section Rendering) und, falls offen, wieder oeffnen */
  function refreshDrawer() {
    return fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var sec = d && d['cart-drawer'];
        var host = document.getElementById('shopify-section-cart-drawer');
        if (!sec || !host) return;
        var cd = host.querySelector('cart-drawer');
        var wasOpen = cd && cd.hasAttribute('open');
        var fresh = new DOMParser().parseFromString(sec, 'text/html').getElementById('shopify-section-cart-drawer');
        if (fresh) host.replaceWith(fresh);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (wasOpen) { var opener = document.querySelector('[aria-controls="cart-drawer"]'); if (opener) opener.click(); }
      })
      .catch(function () {});
  }

  /* Gratis Cafe-Dose: ab THRESHOLD in den Warenkorb legen, darunter wieder entfernen.
     Bleibt nur drin, wenn die Zeile wirklich 0 EUR kostet. */
  function ensureGift(cart) {
    if (giftBusy || giftBroken()) return Promise.resolve(cart);
    var line = giftLine(cart);
    var eligible = paidTotal(cart) >= THRESHOLD;
    if (eligible && !line) {
      giftBusy = true;
      return fetch('/cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ items: [{ id: GIFT_ID, quantity: 1, properties: { _re_gratis: '1' } }] }) })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('add')); })
        .then(fetchCart)
        .then(function (c) {
          var l = giftLine(c);
          if (l && l.final_line_price > 0) { markGiftBroken(); return changeLine(l.key, 0).then(fetchCart); }
          return c;
        })
        .catch(function () { markGiftBroken(); return cart; })
        .then(function (c) { giftBusy = false; refreshDrawer(); return c; });
    }
    if (!eligible && line) {
      giftBusy = true;
      return changeLine(line.key, 0).then(fetchCart)
        .catch(function () { return cart; })
        .then(function (c) { giftBusy = false; refreshDrawer(); return c; });
    }
    if (line && line.quantity > 1) {
      giftBusy = true;
      return changeLine(line.key, 1).then(fetchCart)
        .catch(function () { return cart; })
        .then(function (c) { giftBusy = false; refreshDrawer(); return c; });
    }
    return Promise.resolve(cart);
  }

  /* Karten-ATC (2026-08-07): Klick auf "In den Warenkorb" einer Produktkarte
     legt die Default-Variante DIREKT in den Warenkorb (statt Quick-Buy-Drawer
     mit zweitem Klick) und oeffnet den Warenkorb-Drawer. Trifft nur Karten-
     Buttons (aria-controls="quick-buy..."); Produktseiten nutzen buy-buttons
     und bleiben unberuehrt. Ohne aufloesbare Variante -> natives Quick-Buy.
     Der Drawer wird per Shopify-Section-Rendering (sections:['cart-drawer'])
     frisch geladen, damit die neue Zeile sofort drinsteht. */
  function directAddOnCards() {
    document.addEventListener('click', function (e) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var btn = e.target.closest('[aria-controls^="quick-buy"]');
      if (!btn) return;
      var qb = document.getElementById(btn.getAttribute('aria-controls'));
      if (!qb) return;
      var m = (qb.getAttribute('handle') || '').match(/variant=(\d+)/);
      if (!m) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (btn.hasAttribute('disabled')) return;
      btn.setAttribute('disabled', '');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(m[1], 10), quantity: 1 }], sections: ['cart-drawer'], sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          btn.removeAttribute('disabled');
          if (!res.ok) return;
          var sec = res.data && res.data.sections && res.data.sections['cart-drawer'];
          if (sec) {
            var host = document.getElementById('shopify-section-cart-drawer');
            if (host) {
              var fresh = new DOMParser().parseFromString(sec, 'text/html').getElementById('shopify-section-cart-drawer');
              if (fresh) host.replaceWith(fresh);
            }
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var opener = document.querySelector('[aria-controls="cart-drawer"]');
          if (opener) opener.click();
        })
        .catch(function () { btn.removeAttribute('disabled'); });
    }, true);
  }

  function paintBar(drawer, cart) {
    var inner = drawer.querySelector('.cart-drawer__inner') || drawer;
    var bar = drawer.querySelector('.re-freeship');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 're-freeship';
      bar.innerHTML = '<p class="re-freeship__txt"></p><div class="re-freeship__track"><span class="re-freeship__fill"></span><span class="re-freeship__mark">' + GIFT_SVG + '</span></div><p class="re-freeship__sub"></p>';
      var top = inner.querySelector('.cart-drawer__top');
      if (top && top.parentNode === inner) inner.insertBefore(bar, top.nextSibling);
      else inner.insertBefore(bar, inner.firstChild);
    }
    if (!cart.item_count) { bar.style.display = 'none'; return; }
    bar.style.display = '';
    var paid = paidTotal(cart);
    var pct = Math.max(4, Math.min(100, Math.round((paid / THRESHOLD) * 100)));
    var remain = THRESHOLD - paid;
    var gl = giftLine(cart);
    var giftOk = !!gl && gl.final_line_price === 0;
    var mark = bar.querySelector('.re-freeship__mark');
    if (mark) mark.style.display = giftBroken() ? 'none' : '';
    bar.querySelector('.re-freeship__fill').style.width = pct + '%';
    var txt = bar.querySelector('.re-freeship__txt');
    var sub = bar.querySelector('.re-freeship__sub');
    if (remain > 0) {
      txt.innerHTML = giftBroken()
        ? 'Nur noch <strong>' + money(remain) + '</strong> bis zum kostenlosen Versand'
        : 'Nur noch <strong>' + money(remain) + '</strong> bis zu kostenlosem Versand und deiner gratis Café-Dose';
      sub.textContent = '';
    } else if (giftOk) {
      txt.innerHTML = 'Stark, du hast <strong>kostenlosen Versand</strong> und eine <strong>gratis Café-Dose</strong>';
      sub.textContent = '';
    } else {
      txt.innerHTML = 'Stark, du hast <strong>kostenlosen Versand</strong>';
      sub.textContent = '';
    }
  }

  function paintPay(drawer) {
    var foot = drawer.querySelector('[slot="footer"]');
    if (!foot) return;
    var btn = foot.querySelector('button[name="checkout"]');
    if (btn) {
      var w = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = w.nextNode())) {
        if (n.nodeValue.trim() && n.nodeValue.trim() !== 'Sicher zur Kasse') { n.nodeValue = 'Sicher zur Kasse'; break; }
      }
    }
    if (foot.querySelector('.re-cart-pay')) return;
    var icons = document.querySelectorAll('.footer__payment-icons svg');
    if (!icons.length) return;
    var box = document.createElement('div');
    box.className = 're-cart-pay';
    var label = document.createElement('p');
    label.className = 're-cart-pay__label';
    label.textContent = 'Sicher bezahlen mit';
    var list = document.createElement('ul');
    list.className = 're-cart-pay__list';
    [].slice.call(icons).forEach(function (svg) {
      var li = document.createElement('li');
      li.className = 're-cart-pay__item';
      li.appendChild(svg.cloneNode(true));
      list.appendChild(li);
    });
    var note = document.createElement('p');
    note.className = 're-cart-pay__note';
    note.textContent = 'Kauf auf Rechnung mit Klarna möglich';
    box.appendChild(label);
    box.appendChild(list);
    box.appendChild(note);
    foot.appendChild(box);
  }

  var drawerObserver = null;
  function watchDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d || (drawerObserver && drawerObserver.target === d)) return;
    if (drawerObserver) drawerObserver.mo.disconnect();
    var mo = new MutationObserver(function () {
      var cur = document.querySelector('cart-drawer');
      if (cur && (!cur.querySelector('.re-freeship') || !cur.querySelector('.re-cart-pay'))) render();
    });
    mo.observe(d, { childList: true, subtree: true });
    drawerObserver = { mo: mo, target: d };
  }

  function render() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    injectStyle();
    watchDrawer();
    fetchCart()
      .then(ensureGift)
      .then(function (cart) {
        var d = document.querySelector('cart-drawer');
        if (!d) return;
        paintBar(d, cart);
        paintPay(d);
      })
      .catch(function () {});
  }

  function boot() {
    moveTestimonials();
    directAddOnCards();
    document.addEventListener('cart:refresh', render);
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.matches && e.target.matches('form[action^="/cart/add"]')) setTimeout(render, 1000);
    }, true);
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
